var TemplateLibraryHeaderView;

TemplateLibraryHeaderView = Marionette.LayoutView.extend( {

	id: 'kitbuilder-template-library-header',

	template: '#tmpl-kitbuilder-template-library-header',

	regions: {
		logoArea: '#kitbuilder-template-library-header-logo-area',
		tools: '#kitbuilder-template-library-header-tools',
		menuArea: '#kitbuilder-template-library-header-menu-area'
	},

	ui: {
		closeModal: '#kitbuilder-template-library-header-close-modal'
	},

	events: {
		'click @ui.closeModal': 'onCloseModalClick'
	},

	onCloseModalClick: function() {
		kitbuilder.templates.closeModal();
	}
} );

module.exports = TemplateLibraryHeaderView;
